import { BaseComponent } from "./BaseComponent";

export class Login extends BaseComponent {

    constructor(settings) {
        super(settings, 2);
    }
}